module.exports = __webpack_public_path__ + "static/img/zhuyuanfeiyongqingdan.49123fa5.png";